import Text from 'components/Text/Text';
import React, { useContext, useEffect, useRef } from 'react';
import { IGetCategoriesShortResponse, IGetCategoriesShort } from 'types';
import { useTranslation } from 'react-i18next';
import { DishesContext, IDishesContext } from '../../../dishesState/dishesContext';
import { Select } from 'antd';
import { useFetchData } from 'hooks/useFetchData';
import SelectDropdownReloader from 'components/SelectDropdownReloader/SelectDropdownReloader';
import { getCategoriesShortInfo } from 'backend/categories';
import style from './CategorySelect.module.scss';

const { Option } = Select;

const CategorySelect: React.FC = () => {
	const { setIDCategory, IDSelectedCategory, IDSelectedRestaurant } = useContext<IDishesContext>(DishesContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { response, loading, refetch, responseError } = useFetchData<
		IGetCategoriesShortResponse,
		IGetCategoriesShort
	>(IDSelectedRestaurant ? getCategoriesShortInfo : null, { restaurantIds: [IDSelectedRestaurant || ''] });
	const { t } = useTranslation('listing');

	useEffect(() => {
		refetch();
	}, [IDSelectedRestaurant]);

	const value = IDSelectedRestaurant && !loading ? IDSelectedCategory : undefined;

	return (
		<div className={style.container} data-test="CategorySelect">
			<Text translationNameSpace="listing" translationKey="categoryLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setIDCategory}
				value={value}
				loading={loading}
				disabled={!IDSelectedRestaurant}
				notFoundContent={responseError ? <SelectDropdownReloader onReload={refetch} /> : undefined}
				showSearch={true}
				filterOption={(inputValue, option) =>
					option?.children ? String(option.children).toLowerCase().includes(inputValue.toLowerCase()) : false
				}
				allowClear={true}
				removeIcon={false}
				listItemHeight={response?.data.categories.length}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				placeholder={t('selectPlaceholder')}>
				<>
					<Option className={style.disabledItem} value="empty" disabled={true}>
						<Text
							translationNameSpace="listing"
							translationKey="selectAnyItemPlaceholder"
							asFragment={true}
						/>
					</Option>
					{response?.data.categories.map((el) => (
						<Option className={style.listItem} value={el.id} key={el.id}>
							{el.name}
						</Option>
					))}
				</>
			</Select>
		</div>
	);
};

export default CategorySelect;
